import React from 'react';

import { Card, theme } from 'antd';
import { Mail, Phone, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { VerticalService } from 'models/VerticalService';

import appI18n from '../../../config/i18n';

import './ServiceCard.scss';

const { useToken } = theme;

interface ServiceCardProps {
  service: VerticalService;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const { token } = useToken();
  const { t } = useTranslation(undefined, { i18n: appI18n });

  const primaryColor =
    service.additionalData.primaryColor || token.colorPrimary;

  return (
    <Card
      className="my-services-card"
      style={{
        height: '284px',
        borderRadius: '18px',
        borderColor: token.colorBorderSecondary,
      }}
      styles={{ body: { padding: 0, height: '100%' } }}
    >
      <div className="my-services-container">
        <div
          className="my-services-left-panel"
          style={{ backgroundColor: primaryColor }}
        >
          {service.logoUrl && (
            <div className="my-services-logo-container">
              <img
                src={service.logoUrl}
                alt={`${service.name} logo`}
                className="my-services-logo"
              />
            </div>
          )}
        </div>
        <div className="my-services-right-panel">
          <h3 className="my-services-title" style={{ color: primaryColor }}>
            {service.title}
          </h3>
          <p className="my-services-description">{service.description}</p>
          <div className="my-services-contact-info">
            <div className="my-services-contact-item">
              <User size={18} color={primaryColor} />
              <span>{service.mainContact.name}</span>
            </div>
            <a
              className="my-services-contact-item"
              href={`https://wa.me/${`${service.mainContact.dialCode}${service.mainContact.phone}`.replace(
                /[^0-9]/g,
                ''
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              title={t(
                'scenes.our_services.components.service_card.tooltips.send_whatsapp'
              )}
            >
              <Phone size={18} color={primaryColor} />
              <span>
                {service.mainContact.dialCode} {service.mainContact.phone}
              </span>
            </a>
            <a
              className="my-services-contact-item"
              href={`mailto:${service.mainContact.email}`}
              target="_blank"
              rel="noopener noreferrer"
              title={t(
                'scenes.our_services.components.service_card.tooltips.send_email'
              )}
            >
              <Mail size={18} color={primaryColor} />
              <span>{service.mainContact.email}</span>
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ServiceCard;
